export const SLIDE_HEIGHT = { base: 480, sm: 400 } as const;
